import { Typography, Image } from "antd";
import { useState, useEffect } from "react";
import AlertNotification from "./AlertNotification";

const TrafikverketInfo = ({
  id,
  headline,
  time,
  road,
  severity,
  location,
  position,
  callback,
  settings,
  notification,
  isoTime,
  isMobile,
}) => {
  const [cameraData, setCameraData] = useState([]);
  const [update, setUpdate] = useState(true);
  const [show, setShow] = useState(false);
  const toggle = () => setShow(!show);

  const divStyle = {
    borderBottom: "2px solid",
    borderColor: "white",
    margin: "20px",
  };

  notification === true &&
    id &&
    AlertNotification(
      id,
      road + ":" + headline,
      location,
      time,
      "Trafikverket"
    );

  setInterval(() => {
    setUpdate(!update);
  }, 65000);

  useEffect(() => {
    const fetch = require("node-fetch");
    async function fetchData() {
      const xmlRequest =
        "<REQUEST>" +
        "<LOGIN authenticationkey='07fcff828ad64ffab2b9ea8056cc8388' />" +
        "<QUERY objecttype='Camera' schemaversion='1' limit='3'>" +
        "<FILTER>" +
        "<NEAR name='Geometry.WGS84' value='" +
        position.substring(7, position.indexOf(")")) +
        "' mindistance='0m' maxdistance='10000m'/>" +
        "</FILTER>" +
        "<INCLUDE>Name</INCLUDE>" +
        "<INCLUDE>PhotoTime</INCLUDE>" +
        "<INCLUDE>PhotoUrl</INCLUDE>" +
        "<INCLUDE>Location</INCLUDE>" +
        "<INCLUDE>Geometry.WGS84</INCLUDE>" +
        "<INCLUDE>HasFullSizePhoto</INCLUDE>" +
        "</QUERY>" +
        "</REQUEST>";

      let response = await fetch(
        "https://api.trafikinfo.trafikverket.se/v2/data.json",
        {
          method: "post",
          body: xmlRequest,
        }
      );
      const json = await response.json();
      return json;
    }

    fetchData().then((r) => {
      setCameraData(r.RESPONSE.RESULT[0].Camera);
    });
  }, [position]);

  const NewDataHour = settings.newDataHour;
  const dateObj = new Date(isoTime);
  const timeDiffMillis = Date.now() - dateObj.getTime();
  const timeDiffHours = timeDiffMillis / 1000 / 60 / 60;
  if (timeDiffHours > NewDataHour) {
    callback(false);
  } else {
    callback(true);
  }

  if (headline === "") headline = "No headline";

  return (
    <>
      {isMobile === "true" ? (
        <div style={divStyle}>
          <Typography.Title level={5} onClick={toggle} className="tileHeader">
            {road}: {headline}
          </Typography.Title>
          <p className="tileP">Publicerat: {time}</p>
          <p className="tileP">Påverkansgrad: {severity}</p>
          <p className="tileP">{location}</p>
          {show && (
            <Image.PreviewGroup>
              {cameraData &&
                cameraData.map((value, index) => {
                  if (value.HasFullSizePhoto) {
                    return (
                      <Image
                        width={100}
                        src={value.PhotoUrl + "?type=fullsize"}
                      />
                    );
                  } else {
                    return <Image width={100} src={value.PhotoUrl} />;
                  }
                })}
            </Image.PreviewGroup>
          )}
        </div>
      ) : (
        <div style={divStyle}>
          <Typography.Title level={5} onClick={toggle} className="tileHeader">
            {road}: {headline}
          </Typography.Title>
          <p className="tileP">Publicerat: {time}</p>
          <p className="tileP">Påverkansgrad: {severity}</p>
          <p className="tileP">{location}</p>
          <Image.PreviewGroup>
            {cameraData &&
              cameraData.map((value, index) => {
                if (value.HasFullSizePhoto) {
                  return (
                    <Image
                      width={100}
                      src={value.PhotoUrl + "?type=fullsize"}
                    />
                  );
                } else {
                  return <Image width={100} src={value.PhotoUrl} />;
                }
              })}
          </Image.PreviewGroup>
        </div>
      )}
    </>
  );
};

export default TrafikverketInfo;
